<template>
  <div class="ion-padding bg-brand-black text-white text-center py-16">
    <h2 class="text-xl font-semibold mb-2">Under maintenance</h2>
    <p class="text-sm text-brand-light-gray mb-6">
      Pineapple is temporarily unavailable. Please try again soon.
    </p>
    <ion-button expand="block" fill="outline" color="light" @click="reload">
      Refresh
    </ion-button>
  </div>
</template>

<script setup lang="ts">
import {IonButton} from '@ionic/vue';

const reload = () => {
  window.location.reload();
};
</script>
